import { render, staticRenderFns } from "./PlayerNew.vue?vue&type=template&id=ff3342bc"
import script from "./PlayerNew.vue?vue&type=script&lang=js"
export * from "./PlayerNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports